export default {
  common: {
    home: '首页',
    workbench: '工作台',
    search: '查询',
    reset: '重置',
    empty: '暂无数据',
    emptyDesc: '当前条件下没有可展示的数据',
    loading: '加载中…',
    viewMore: '查看更多',
    mainNav: '主导航',
    subNav: '子导航',
    subNavOpen: '打开子菜单',
    back: '返回',
    detail: '详情',
    operation: '操作',
    confirm: '确定',
    cancel: '取消',
    save: '保存',
    edit: '编辑',
    delete: '删除',
    add: '新增',
    export: '导出',
    success: '操作成功',
    failed: '操作失败',
    logout: '退出登录',
    logoutConfirm: '确定要退出登录吗？',
    all: '全部',
    yes: '是',
    no: '否',
    pleaseInput: '请输入',
    pleaseSelect: '请选择',
    startTime: '开始时间',
    endTime: '结束时间',
    selectMonth: '选择月份',
  },
  field: {
    keywords: '关键词',
    personnel: '人员信息',
    role: '角色',
    status: '状态',
    employment: '在职状态',
    sex: '性别',
    mobile: '手机',
    email: '邮箱',
    username: '用户名',
    realName: '姓名',
    deviceName: '设备名称',
    deviceCode: '機號',
    model: '机型',
    manufacturer: '厂商',
    template: '模板',
    code: '编码',
    title: '名称',
    points: '积分',
    workHours: '累计工时',
    kilometer: '公里数',
    initialWorkHours: '初始工作时长',
    initialKilometer: '初始公里数',
    maintenanceTime: '初始保养时间',
  },
  btn: {
    bindDevice: '绑定设备',
    unbind: '解绑',
    unlink: '解除',
    unlinkConfirm: '是否解除 {name} 的绑定？',
    linkUser: '关联机手',
    initPwd: '初始化密码',
    view: '查看',
    editDevice: '编辑设备',
  },
  table: {
    index: '序号',
    operation: '操作',
  },
  status: {
    enabled: '启用',
    disabled: '停用',
    onJob: '在职',
    offJob: '离职',
    available: '可用',
    warehouse: '仓库',
    unknown: '未知',
    male: '男',
    female: '女',
  },
  detail: {
    device: '设备详情',
    machinist: '机手详情',
    captain: '队长详情',
    workbenchDesc: '数据概览与待办事项',
    recentClockIn: '最近打卡记录',
    recentPoints: '最近积分记录',
    clockTime: '打卡时间',
    clockAddress: '打卡地址',
    deviceLabel: '设备',
    monthWorkDays: '本月打卡天数',
    monthOtDays: '本月OT打卡天数',
    monthOtHours: '本月OT时长',
    monthZhiDays: '本月中直打卡天数',
    monthZhiHours: '本月中直时长',
    basicInfo: '基本信息',
    workTime: '工时',
    tabMachinist: '机手',
    tabDevice: '设备',
    unitDay: '天',
    unitHour: '小时',
    unitPoint: '分',
    score: '分值',
  },
  dashboard: {
    stats: '业务数据分布',
    quickLinks: '快捷入口',
    workbenchTitle: '今日工作台',
    workbenchType: '类型',
    workbenchItem: '事项',
    workbenchSubmitter: '提交人',
    workbenchTime: '时间',
    workbenchAction: '操作',
    workbenchEmpty: '暂无待办，一切正常',
    workbenchMaintenance: '保养审核',
    workbenchSpecial: '特殊任务',
    workbenchImprove: '技能提升',
    workbenchAnomaly: '考勤异常',
    workbenchOvertime: '今日 OT',
    workbenchApprove: '通过',
    workbenchReject: '驳回',
    workbenchConfirmTitle: '确认审核',
    maintenanceAudit: '保养待审核',
    specialAudit: '特殊任务待审核',
    improveAudit: '技能提升待审核',
  },
  improveDetail: {
    title: '详情',
    taskName: '任务名称',
    score: '分值',
    staffLimit: '人员限制',
    unlimited: '无限制',
    taskDesc: '任务描述',
    taskMaterial: '任务材料',
    submitter: '提交人',
    submitPhotos: '提交相关照片',
    submitContent: '提交内容',
    auditComment: '审核意见',
    passStatus: '是否通过',
    close: '关闭',
    passed: '通过',
    rejected: '不通过',
    opSuccess: '操作成功',
    opFailed: '操作失败',
  },
  salary: {
    generate: '生成工资条',
    export: '导出工资条',
    editTitle: '编辑工资条',
    month: '月份',
    name: '姓名',
    employment: '在职状态',
    totalEarnings: '总收入',
    allowance: '津贴',
    deduction: '罚款',
    mpfDeduction: 'MPF扣款',
    incomeAfterMpf: '扣除MPF后收入',
    netPay: '应发工资',
    remarks: '备注',
    clockDays: '打卡天数',
    annualLeaveDays: '带薪年假天数',
    otDays: 'OT天数',
    otHours: 'OT时长',
    zhiDays: '中直天数',
    zhiHours: '中直时长',
    tongxiaoDays: '通宵天数',
    weekendDays: '周末天数',
    nightShiftDays: '夜班天数',
    allowancePlaceholder: '请输入津贴金额',
    deductionPlaceholder: '请输入罚款金额',
    remarksPlaceholder: '请输入备注',
    loadFailed: '加载工资条失败',
    selectMonthFirst: '请先选择月份',
    selectMonth: '请选择月份',
    generateConfirmTitle: '确认生成',
    generateConfirmBody: '将重新生成 {month} 月工资条，该月已有数据及手工编辑将被覆盖。是否继续？',
    generateConfirmOk: '继续生成',
    generateSuccess: '生成成功',
    generateFailed: '生成失败',
    exportFailed: '导出失败',
    editSuccess: '编辑成功',
    editFailed: '编辑失败',
    exportFileName: '{month}工资条.xls',
  },
  attendance: {
    recordTitle: '打卡记录',
    export: '导出',
    exportSummary: '导出数据汇总',
    exportDetail: '导出数据明细',
    clockType: '打卡类型',
    clockIn: '上班',
    clockOut: '下班',
    onMachine: '上机打卡',
    offMachine: '落机打卡',
    ot: 'OT',
    zhongzhi: '中直',
    shiftType: '班次',
    dayShift: '白班',
    nightShift: '夜班',
    status: '状态',
    normal: '正常',
    late: '迟到',
    earlyLeave: '早退',
    missing: '缺卡',
    abnormalLocation: '异常位置',
    loadFailed: '加载失败',
    exportFailed: '导出失败',
    selectTimeRange: '请选择时间范围',
    selectMonth: '请选择月份',
    overtimeTime: '加班时间',
    overtimeDuration: '加班时长',
    workContent: '工作内容',
    location: '地点',
    projectSite: '项目地盘',
    clockDays: '打卡天数',
    otDays: 'OT天数',
    otHours: 'OT时长',
    zhiDays: '中直天数',
    zhiHours: '中直时长',
    tongxiaoDays: '通宵天数',
    nightShiftDays: '夜班天数',
    lateCount: '迟到次数',
    earlyLeaveCount: '早退次数',
    signTime: '签字时间',
    signImage: '签字图片',
    audit: '审核',
    pendingAudit: '待审核',
    captainApproved: '队长已通过',
    captainRejected: '队长已拒绝',
    adminApproved: '超管已通过',
    adminRejected: '超管已拒绝',
    leaveType: '类型',
    leave: '请假',
    annualLeave: '年假',
    startDate: '开始日期',
    endDate: '结束日期',
    days: '天数',
    reason: '原因',
    createdAt: '创建时间',
    captainReviewHint: '仅超级管理员可执行队长打卡审核',
    annualLeaveBalance: '年假余额',
    machinistInfo: '机手信息',
    leaveYear: '年份',
    yearPlaceholder: '例如 2026',
    startDateOnJob: '机手入职日期',
    currentYearDays: '本年度可用天数(只读)',
    carryoverDays: '上年结转天数',
    totalAnnualDays: '总年假天数',
    usedAnnualDays: '已请年假天数',
    remainAnnualDays: '剩余年假天数',
    remark: '备注',
    saveSuccess: '保存成功',
    saveFailed: '保存失败',
    clockRemind: '打卡提醒',
    clockLocation: '打卡地点',
    annualLeaveRule: '年假规则',
    makeupDate: '补卡日期',
    makeupTime: '补卡时间',
    makeupType: '补卡类型',
    anomalyReason: '异常原因',
    locationName: '地点名称',
    locationDesc: '地点描述',
    longitude: '经度',
    latitude: '纬度',
    addressId: '地址ID',
    manualRecord: '手动录卡',
    manualRecordTitle: '批量手动录入打卡',
    manualRecordSelectCaptain: '请选择队长',
    manualRecordSelectCaptainFirst: '请先选择队长',
    manualRecordTeamList: '人员列表（含队长）',
    manualRecordMachinistList: '机手列表',
    manualRecordNoTeam: '该队长下暂无人员',
    manualRecordNoMachinist: '该队长下暂无机手',
    manualRecordNoDevice: '未绑定设备',
    manualRecordSelectDevice: '请选择设备',
    manualRecordDeviceRequired: '请为已选人员选择设备',
    manualRecordSelectMachinist: '请至少选择一名人员',
    manualRecordOnTime: '上班时间',
    manualRecordOffTime: '下班时间',
    manualRecordDefaultOn: '默认 08:30',
    manualRecordDefaultOff: '默认 18:00',
    manualRecordTypes: '录入类型',
    manualRecordTypeRequired: '请至少选择录入上班或下班打卡',
    manualRecordAddressPlaceholder: '选填，默认「管理员录入」',
    manualRecordHint: '选择队长后，列表含队长本人及其下属机手；每人可单独选择绑定设备（默认最新一条）；未绑定设备的人员无法勾选；若当日已有同类型记录将覆盖更新。',
    manualOtRecordTitle: '批量手动录入OT/中直',
    manualOtRecordCheckinTime: '打卡时间',
    manualOtRecordDefaultTime: '默认 18:00',
    manualOtRecordTypes: '录入类型',
    manualOtRecordTypeRequired: '请至少选择录入OT或中直',
    manualOtRecordOtHours: 'OT时长',
    manualOtRecordContentsPlaceholder: '选填，默认「管理员录入」',
    manualOtRecordHint: '选择队长后，列表含队长本人及其下属机手；每人可单独选择绑定设备；中直固定1小时；若当日已有同类型记录将覆盖更新。',
    configure: '配置',
    notMaintained: '未维护',
    annualLeaveRuleLink: '入职年限与年假天数（按租户配置）',
    machinist: '机手',
    captainReview: '队长打卡审核',
    clockReview: '打卡审核',
    recentTwoDays: '近两日',
    history: '历史',
    noClockRecords: '暂无打卡记录',
    evaluated: '已评估',
    pendingEvaluate: '待评估',
    noRecord: '无记录',
    none: '无',
    reviewAndEvaluate: '审核并评估',
    captainEvaluate: '队长评估',
    evaluateContent: '评价内容',
    evaluateContentPlaceholder: '请输入评价内容',
    reject: '拒绝',
    pass: '通过',
    complaint: '是否投诉',
    submitReview: '提交审核',
    onlySuperAdminSubmit: '仅超级管理员可提交审核',
    missingReviewTarget: '缺少审核对象或日期',
    cannotGetCurrentUser: '无法获取当前登录用户',
    reviewSubmitSuccess: '审核提交成功',
    reviewSubmitFailed: '审核提交失败',
    efficiencyPass: '效率通过',
    attitudePass: '态度通过',
    constructionPass: '施工反馈通过',
    hasComplaint: '有投诉',
    noContent: '无内容',
    captainName: '队长姓名',
    placeholderNameUserMobile: '姓名/用户名/手机号',
    otZhongzhiClock: 'OT/中直打卡',
    onMachineColon: '上机：',
    offMachineColon: '落机：',
    otColon: 'OT：',
    zhongzhiColon: '中直：',
    evaluateColon: '评估：',
    viewDuration: '查看时长',
    seconds: '秒',
    craneRemind: '吊机打卡须知',
    excavatorRemind: '挖机打卡须知',
    enterCraneRemind: '请输入吊机打卡须知内容',
    enterExcavatorRemind: '请输入挖机打卡须知内容',
    enterViewDuration: '请输入查看时长',
    defaultRulesWarning: '当前租户尚未保存自定义规则，下方为系统默认对照表。修改后点击「保存配置」即可按租户生效。',
    ruleInfoTitle: '配置「入职工龄（周年）— 本周期年假天数」；每年在对应入职周年日进入新周期（12 个月）。最高一档表示该周年及以上均按此天数发放。',
    addRule: '新增规则',
    restoreDefault: '恢复默认',
    saveConfig: '保存配置',
    serviceYears: '入职工龄（周年）',
    annualDaysInCycle: '本周期年假天数',
    description: '说明',
    ruleTextPlaceholder: '选填，留空则自动生成',
    fullYears: '满',
    yearsAndAbove: '周年及以上',
    yearsAnniversary: '周年',
    confirmRestoreDefault: '将恢复为系统默认规则（尚未保存），是否继续？',
    restoreDefaultTitle: '恢复默认',
    keepOneRule: '请至少保留一条规则',
    invalidAnniversary: '请填写有效的入职周年',
    invalidAnnualDays: '请填写年假天数',
    rowInvalidPrefix: '第 {row} 行：',
  },
  attendanceDialog: {
    anomalyAuditTitle: '考勤异常审核',
    annualLeaveAuditTitle: '请假/年假审核',
    recordDetailTitle: '打卡详情',
    signDetailTitle: '签字详情',
    payslipDetailTitle: '工资条详情',
    clockLocationTitle: '打卡地点',
    auditRemark: '审核意见',
    auditRemarkPlaceholder: '请输入审核意见',
    auditResult: '审核结果',
    relatedPhotos: '相关照片',
    signerName: '签字人姓名',
    signImage: '签字图片',
    signedAt: '签字时间',
    locationName: '名称',
    locationDesc: '描述',
    selectAddress: '选择地址',
    openGoogleMaps: '前往谷歌地图',
    enterLongitude: '请输入经度',
    enterLatitude: '请输入纬度',
    longitudeRange: '经度范围为-180到180',
    latitudeRange: '纬度范围为-90到90',
    leaveTypeAnnual: '年假',
    leaveTypeNormal: '请假',
    timeRange: '时间',
    annualLeavePay: '带薪年假工资（按日薪）',
    attendanceNote: '考勤说明',
    sundayOtDays: '周日加班天数',
    reloginRequired: '请重新登录后再试',
    auditSuccess: '审核成功',
    auditFailed: '审核失败',
    hourSuffix: '小时',
  },
  maintenance: {
    back: '返回',
    templateLabel: '模板',
    addPart: '新增零部件',
    addProject: '新增保养项目',
    edit: '编辑',
    audit: '审核',
    detail: '详情',
    submitRecord: '提交记录',
    deviceCode: '機號',
    deviceName: '设备名称',
    model: '机型',
    status: '状态',
    pending: '待执行',
    pendingAudit: '待审核',
    completed: '已完成',
    overdue: '已逾期',
    rejected: '驳回',
    loadFailed: '加载失败',
    planProject: '保养项目',
    planContent: '保养内容',
    requiredMaterials: '所需物料',
    dose: '单台用量',
    frequencyType: '保养类型',
    fixedCycle: '固定周期',
    driveKm: '行驶公里',
    workHoursType: '工作时长',
    days: '天数',
    km: '公里',
    hours: '小时',
    enable: '启用',
    disable: '停用',
    close: '关闭',
    partName: '零部件名称',
    scheduleDate: '预计执行日期',
    assignee: '负责人',
    materials: '相关材料',
    submitInfo: '提交信息',
    auditStatus: '审核状态',
    pass: '通过',
    reject: '不通过',
    needPartName: '请输入零部件名称',
    editPart: '编辑零部件',
  },
  maintenanceDuplicate: {
    month: '月份',
    deviceId: '设备ID',
    duplicateCount: '重复机手数',
    duplicateMachinists: '重复机手',
    firstCheckTime: '首次选重时间',
    lastCheckTime: '最近选重时间',
    loadFailed: '加载失败',
  },
  deviceDetail: {
    title: '设备详情',
    editDevice: '编辑设备',
    tabInfo: '基本信息',
    tabWorkTime: '工时',
    codeColon: '機號',
    modelColon: '机型',
    totalHoursColon: '累计工时',
    kmColon: '公里数',
    totalWorkHours: '累计工作时长',
    hourUnit: 'h',
  },
  maintenanceAudit: {
    title: '保养审核',
    partName: '零部件名称',
    maintenanceContent: '保养内容',
    scheduleDate: '预计执行日期',
    assignee: '负责人',
    materials: '相关材料',
    submitInfo: '提交信息',
    auditStatus: '审核状态',
    pass: '通过',
    reject: '不通过',
  },
  personnelDialog: {
    linkMachinist: '关联机手',
    personnel: '人员',
    captain: '队长',
    bindDevice: '绑定设备',
    device: '设备',
    selectDevice: '请选择设备',
    selectRequired: '请选择',
  },
  deviceForm: {
    template: '模板',
    fullPhoto: '全身照片',
    nameplatePhoto: '铭牌照片',
    workKm: '工作公里',
    initialWorkKm: '初始工作公里',
    addKmTitle: '增加公里数',
    kmToAdd: '增加公里数',
  },
  personnelDetail: {
    recentCheckin: '最近打卡记录',
    recentPoints: '最近积分记录',
    points: '积分',
    monthCheckinDays: '本月打卡天数',
    monthOtDays: '本月OT打卡天数',
    monthOtHours: '本月OT时长',
    monthZhiDays: '本月中直打卡天数',
    monthZhiHours: '本月中直时长',
    tabMachinist: '机手',
    tabCaptain: '队长',
    noData: '暂无数据',
  },
  personnelList: {
    captainSearch: '队长信息',
    machinistSearch: '机手信息',
    searchPlaceholder: '姓名/用户名/手机号/邮箱',
    linkMachinist: '关联机手',
    bindDevice: '绑定设备',
    editMachinist: '编辑机手',
    addMachinist: '新增机手',
    editCaptain: '编辑队长',
    addCaptain: '新增队长',
    captainSelect: '所属队长',
    captainSelectPh: '请选择队长',
    captainSelectRequired: '请选择所属队长',
    roleMachinist: '机手',
    roleCaptain: '队长',
    resetPwd: '重置密码',
    colId: '编码',
    colCaptainId: '队长ID',
    colIndex: '序号',
    colName: '姓名',
    colEnglishName: '英文名',
    colIdCard: '身份号码',
    colSex: '性别',
    colUsername: '用户名',
    colPassword: '密码',
    colEmail: '邮箱',
    colAddress: '家庭住址',
    colStartDate: '入职时间',
    colEndDate: '离职时间',
    colEmployment: '在职状态',
    colMobile: '手机',
    colPoints: '分数',
    colStatus: '状态',
    colLoginTime: '最近登录时间',
    colOperation: '操作',
    employmentActive: '在职',
    employmentInactive: '离职',
    sexUnknown: '未知',
    sexMale: '男',
    sexFemale: '女',
    statusDisabled: '禁用',
    statusEnabled: '启用',
    importMachinist: '批量导入',
    importMachinistTitle: '批量导入机手',
    importMachinistTip: '请下载模板填写后上传。队长ID 填「队长管理」列表中的队长ID；默认密码 123456；仅新建机手并关联队长，不会修改已有机手。',
    importDownloadTemplate: '下载导入模板',
    importDragTip: '将 Excel 拖到此处，或点击选择 .xls / .xlsx 文件',
    importSubmit: '开始导入',
    importSelectFile: '请先选择 Excel 文件',
    importTemplateFailed: '模板下载失败',
    importColRow: '行号',
    importColStatus: '结果',
    importColMessage: '说明',
    importSuccess: '成功',
    importFailed: '失败',
  },
  feedbackList: {
    keywordLabel: '标题关键字',
    titleLabel: '标题',
    typeLabel: '类型',
    statusLabel: '状态',
    reporterLabel: '反馈人',
    reply: '回复',
    colId: '反馈ID',
    colTitle: '标题',
    colStatus: '状态',
    colType: '类型',
    colReporter: '反馈人',
    colContent: '意见内容',
    colContact: '联系方式',
    colCreatedAt: '创建时间',
    statusDone: '已处理',
    statusPending: '待处理',
    typeSuggestion: '功能建议',
    typeBug: 'BUG反馈',
    typeUsage: '使用问题',
    typeOther: '其他',
  },
  feedbackReply: {
    title: '反馈回复',
    reporter: '反馈人',
    contact: '联系方式',
    content: '意见内容',
    relatedImages: '相关图片',
    replyContent: '回复内容',
    needReply: '请输入回复内容',
    replySuccess: '回复成功',
  },
  platformRenewal: {
    tip: '共享 SaaS 租户在此开通或续期。支持按月（1/3/6个月）或按年（1-5年）续期；新建租户后需先开通才能登录；续期记录见「开通记录」。',
    keywords: '关键词',
    keywordsPh: '租户码/名称',
    renew: '续期',
    open: '开通',
    renewTitle: '租户续期',
    openTitle: '租户开通',
    tenant: '租户',
    currentExpire: '当前到期',
    durationType: '续期方式',
    byMonth: '按月',
    byYear: '按年',
    months: '续期月数',
    month1: '1 个月',
    month3: '3 个月',
    month6: '6 个月',
    years: '续期年限',
    yearSuffix: ' 年',
    expireCalc: '到期计算',
    renewFromToday: '从今日重新计算到期',
    hintMonth: '不勾选则在当前到期日（若已过期则从今天）上叠加所选月数',
    hintYear: '不勾选则按原开通日起算新年限',
    remark: '备注',
    remarkPh: '选填',
    colTenantCode: '租户码',
    colTenantName: '租户名称',
    colYears: '当前年限',
    colOpenedAt: '开通时间',
    colExpireAt: '到期时间',
    colStatus: '状态',
    colOperation: '操作',
    monthlyOrUnset: '按月/未按年',
    selectDuration: '请选择续期方式',
    selectMonths: '请选择 1 / 3 / 6 个月',
    selectYears: '请选择年限',
  },
  platformLogs: {
    tip: '展示各共享租户开通与续期的历史记录（只读）。',
    keywordsPh: '租户码/名称/操作人',
    eventOpen: '开通',
    eventRenew: '续期',
    monthly: '按月',
    yearSuffix: '年',
    colTenantCode: '租户码',
    colTenantName: '租户名称',
    colEventType: '类型',
    colYears: '年限',
    colOpenedAt: '起算时间',
    colExpireBefore: '变更前到期',
    colExpireAfter: '变更后到期',
    colOperator: '操作人',
    colRemark: '备注',
    colCreatedAt: '操作时间',
    loadFailed: '加载失败',
  },
  loginPage: {
    tagline: '工程机械智慧管理平台',
    headline: '连接现场与总部',
    headline2: '让机手管理更高效',
    feature1: 'GPS 考勤与工资条一体化',
    feature2: '设备保养计划与任务提醒',
    feature3: '任务协同与移动端联动',
    register: '注册',
    forgotPwd: '忘记密码？',
    tenantLoginTitle: '租户后台登录',
    tenantLoginSubtitle: '请输入租户码与管理员账号',
    tenantCode: '租户码',
    tenantCodePh: '如 test2',
    tenantCodeRequired: '租户码不能为空',
    usernameRequired: '用户名不能为空',
    passwordRequired: '密码不能为空',
    loginBtn: '登录',
    passwordLabel: '密码',
    platformAdminDenied: '该账号不能从租户后台登录',
    adminAccountPh: '管理员账号',
    mobile: '手机号码',
    mobilePh: '请输入手机号',
    verificationCode: '验证码',
    codePh: '请输入验证码',
    sendCode: '发送验证码',
    accountPassword: '账户密码',
    passwordPh: '请输入密码',
    confirmPassword: '确认密码',
    confirmPasswordPh: '请再次输入密码',
    changePasswordBtn: '修改密码',
    backToLogin: '已有账号？返回登录',
    codeRequired: '验证码不能为空',
    confirmPasswordRequired: '请再次确认密码',
    superadminPageTitle: '平台超管后台',
    superadminPageDesc: '统一管理多租户开通、续期与平台配置，简洁、安全、可控。',
    superFeature1: '租户生命周期与订阅管理',
    superFeature2: '全局 API 与系统参数配置',
    superFeature3: '安全隔离的多租户数据模型',
    portalBadge: 'Platform Admin',
    portalTitle: '平台超管后台',
    portalDesc: '登录 {brand}，管理租户开通、续期与全局配置',
    adminUsernamePh: '平台超管账号',
    rememberUsername: '记住用户名',
    backTenantLogin: '返回租户后台登录',
    notPlatformAdmin: '该账号不是平台超管，请使用租户后台登录',
  },
  dashboardHome: {
    statMachinist: '机手数量',
    statCaptain: '队长数量',
    statDevice: '设备数量',
    statMaintenance: '保养任务',
    statSpecialTask: '特殊任务',
    statImprove: '技能提升',
    statUsers: '用户数量',
    quickAttendance: '打卡记录',
    quickUsers: '用户管理',
    quickDevice: '设备管理',
    quickMaintenance: '保养任务',
    chartMachinist: '机手',
    chartCaptain: '队长',
    chartDevice: '设备',
    chartMaintenance: '保养',
    chartSpecialTask: '特殊任务',
    chartImprove: '技能提升',
    chartUsers: '用户',
    demoTodaySales: '今日销售额',
    demoGrowth: '增长',
    demoTodayPurchase: '今天采购额',
    demoTodayFlow: '今日流水',
    demoSalesStatus: '销售情况',
    demoPartnerStats: '合作企业统计',
    demoSupplier: '供应商',
    demoPurchaseStatus: '采购情况',
  },
  scoreLottery: {
    tabConfig: '抽奖配置',
    tabPrize: '奖品管理',
    pointsPerDraw: '每满多少积分可抽一次',
    pointsTip: '用户总积分 ÷ 该值 = 可获得抽奖次数（减去已抽次数）',
    saveConfig: '保存配置',
    addPrize: '新增奖品',
    probSum: '已启用奖品概率合计：',
    probOver: '（超过 100%，请调整）',
    colSort: '排序',
    colLevel: '等级',
    colLevelName: '等级名称',
    colPrizeName: '奖品名称',
    colProbability: '概率',
    colStatus: '状态',
    editPrize: '编辑奖品',
    addPrizeTitle: '新增奖品',
    winProbability: '中奖概率',
    probHint: '0～1，如 0.01 表示 1%',
    levelNamePh: '如：一等奖',
    prizeNamePh: '奖品名称',
    needLevel: '请填写等级',
    needPrizeName: '请填写奖品名称',
    needProbability: '请填写中奖概率',
    pointsMinWarning: '每满积分须大于 0',
    deleteTitle: '删除确认',
    deleteConfirm: '确定删除奖品「{name}」？已有抽奖记录的等级无法删除。',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
  },
  scoreRule: {
    addRule: '新增',
    levelName: '等级名称',
    requiredPoints: '所需积分',
    needLevelName: '请输入等级名称',
    needRequiredPoints: '请输入所需积分',
  },
  scoreReward: {
    addProduct: '新增商品',
    itemName: '物品名称',
    itemDesc: '物品描述',
    itemImage: '物品图片',
    needItemName: '请输入物品名称',
    needItemDesc: '请输入物品描述',
    needImage: '请上传图片',
  },
  scoreRedemption: {
    add: '新增',
    nameKeyword: '姓名关键词',
    user: '用户',
    consumedPoints: '消耗积分',
    redemptionTime: '兑换时间',
    redeemItem: '兑换物品',
    needUser: '请选择用户',
    needReward: '请选择要兑换的物品',
  },
  scoreLotteryRecord: {
    userName: '用户姓名',
    account: '账号',
    pointsTier: '积分档位',
    redeemStatus: '兑换状态',
    drawTime: '抽奖时间',
    redeemed: '已兑换',
    notRedeemed: '未兑换',
    keywordPlaceholder: '姓名/账号',
  },
  scoreRemind: {
    usageGuide: '积分使用说明',
    needContent: '请输入积分使用说明',
  },
  platformAdmin: {
    tenantsTip: '维护租户基础信息与后台管理员账号；共享租户开通/续期请在「租户续期」，历史见「开通记录」。',
    addTenant: '新增租户',
    editTenant: '编辑租户',
    tenantCode: '租户码',
    tenantName: '租户名称',
    deployType: '部署类型',
    sharedSaas: '共享租户（SaaS）',
    standalone: '独立部署',
    enable: '启用',
    disable: '停用',
    notOpened: '未开通',
    expired: '已到期',
    notSet: '未设置',
    sharedDefault: '（共享默认）',
    edit: '编辑',
    yearsSuffix: '年',
  },
  systemSetting: {
    title: '系统参数',
    toScore: '上机打卡分',
    offScore: '落机打卡分',
    goToWork: '上机打卡时间',
    goOffWork: '落机打卡时间',
    otScore: 'OT/中直打卡分',
    maintenanceScore: '完成保养分值',
    radius: '打卡有效半径（单位：米）',
    complaintDeduction: '投诉减分',
    nightShiftExtra: '机手夜班日薪加额（元）',
    tongxiaoMultiplier: '通宵工资倍数（日薪）',
    restoreDefault: '恢复默认',
    save: '保存',
    saveSuccess: '保存成功',
    saveFailed: '保存失败',
    loadFailed: '加载失败',
    pleaseSelect: '请选择',
    defaultNightShift: '默认100',
    defaultTongxiao: '默认1.00',
  },
  menu: {
    home: '应用首页',
    attendance: '考勤管理',
    attendanceList: '打卡记录',
    overtime: 'OT/中直记录',
    Summary: '打卡汇总',
    salary: '员工工资条',
    clockIn: '打卡地点',
    sign: '签字记录',
    clockRemind: '打卡须知',
    attendanceAnomaly: '考勤异常',
    attendanceAnnualLeave: '请假/年假审核',
    attendanceAnnualLeaveBalance: '年假余额配置',
    attendanceAnnualLeaveRule: '入职年限与年假天数',
    attendanceCaptainReview: '队长打卡审核',
    equipment: '设备管理',
    deviceTemplate: '设备模板',
    equipmentList: '设备列表',
    deviceWorkTimeStats: '设备工时统计',
    deviceUtilization: '设备利用率对比',
    maintenanceRecord: '保养记录',
    deviceDuplicateRecord: '设备选重记录',
    task: '特殊任务',
    specialTask: '特殊任务',
    specialTaskSubmitRecord: '提交记录',
    captainTask: '特殊任务',
    captainSpecialTask: '特殊任务',
    captainSpecialTaskSubmitRecord: '提交记录',
    captainMaintenance: '保养任务',
    captainMaintenanceSubmitRecord: '提交记录',
    improve: '技能提升',
    improveTask: '任务列表',
    improveTaskSubmitRecord: '提交记录',
    score: '积分管理',
    scoreRule: '积分规则',
    scoreRecord: '积分记录',
    rewardRecord: '兑换记录',
    rewardRemind: '积分使用说明',
    lottery: '积分抽奖',
    lotteryRecord: '抽奖记录',
    feedback: '用户反馈',
    system: '系统维护',
    userList: '用户列表',
    setting: '系统参数',
    brandSetting: '品牌设置',
    ChangePsw: '修改密码',
    message: '消息管理',
    operationLogs: '操作审计',
    machinist: '机手管理',
    captainMachinist: '机手管理',
    Captain: '队长管理',
    maintenance: '保养计划',
    'machinist-detail': '机手详情',
    'captain-detail': '队长详情',
    'device-detail': '设备详情',
    platformTenants: '租户信息',
    platformTenantRenewal: '租户续期',
    platformTenantLogs: '开通记录',
    platformVersionControl: '版本控制',
  },
  deviceList: {
    add: '新增',
    addKm: '增加公里数',
    workDuration: '工作时长',
    loadFailed: '加载失败',
  },
  taskSubmit: {
    recordId: '记录ID',
    taskName: '任务名称',
    submitterName: '提交人姓名',
    submitterUsername: '提交人用户名',
    submitterMobile: '提交人手机',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    statusNotSubmitted: '未提交',
    statusPending: '待审核',
    statusApproved: '审核通过',
    statusRejected: '审核不通过',
    auditStatus: '审核状态',
    pass: '通过',
    reject: '不通过',
    keywordTaskOrName: '任务名称/姓名关键词',
    missingRecordId: '缺少提交记录 ID',
    loadDetailFailed: '加载详情失败',
    invalidRecordId: '记录 ID 无效，请关闭后重试',
  },
  improveList: {
    ended: '已结束',
    taskId: '任务ID',
    startTime: '开始时间',
    endTime: '截至时间',
  },
  improveSubmit: {
    statusInProgress: '进行中',
    statusPass: '通过',
    statusFail: '不通过',
    material: '材料',
    reportContent: '汇报内容',
  },
  systemPersonnel: {
    roleNormalAdmin: '普通管理员',
    roleSuperAdmin: '超级管理员',
  },
  systemAccount: {
    title: '账号设置',
  },
  changePassword: {
    title: '修改密码',
    oldPwd: '旧密码',
    newPwd: '新密码',
    confirmPwd: '确认新密码',
    oldPwdPh: '请输入旧密码',
    newPwdPh: '请输入新密码',
    confirmPwdPh: '请再次输入新密码',
    pwdMismatch: '两次输入的新密码不一致',
    submit: '提交',
    needOld: '请输入旧密码',
    needNew: '请输入新密码',
    needConfirm: '请再次输入新密码',
    success: '修改成功',
    failed: '修改失败',
  },
  brandSetting: {
    systemName: '后台系统名称',
    systemNamePh: '例如：晋辉智机通·某某租户后台',
    logo: '后台Logo',
    logoTip: '上传成功后将立即同步到登录后右侧顶栏',
    themeColor: '后台背景颜色',
    recommended: '推荐颜色',
    previewTitle: '后台系统名称预览',
    headerPreview: '顶栏预览',
    remark: '品牌备注说明',
    remarkPh: '可填写租户后台说明，例如：仅限 test2 租户后台使用',
    save: '保存品牌配置',
    saveSuccess: '保存成功',
    saveSynced: '保存成功，品牌已同步更新',
    saveFailed: '保存失败',
    loadFailed: '加载失败',
    imageOnly: '只能上传图片文件',
    logoUploaded: 'Logo 已上传并同步',
  },
  deviceTemplate: {
    keyword: '关键字',
    templateId: '模板ID',
    templateName: '模板名称',
    templateIntro: '模版介绍',
    maintenancePlan: '保养计划',
  },
  deviceWorkTime: {
    tip: '工时按考勤规则折算（落机 8h/次 · OT 按选择时长 · 中直 1h/次 · 通宵 8h/次），数据来自打卡原始记录。',
    utilizationTip: '利用率 = 当月合计工时 ÷（（当月天数 − 4 天）× 8h）× 100%。超过 100% 表示加班/多班次超出单班基准。工时按考勤规则折算。',
    exportExcel: '导出 Excel',
    exportFailed: '导出失败',
    selectMonth: '请选择月份',
    operatorDetail: '机手明细',
    workTimeDetail: '工时详情',
    allDevices: '全部设备',
    withHoursOnly: '仅有工时',
    allSites: '全部工地',
    scope: '范围',
    sort: '排序',
    sortDesc: '利用率高 → 低',
    sortAsc: '利用率低 → 高',
    month: '月份',
    site: '工地',
    primarySite: '主要工地',
    workDays: '出勤天数',
    operatorCount: '机手人数',
    standardTime: '落机工时(h)',
    otTime: 'OT工时(h)',
    zhiTime: '中直工时(h)',
    tongxiaoTime: '通宵工时(h)',
    totalTime: '合计(h)',
    totalHours: '累计工时',
    rank: '排名',
    utilizationRate: '利用率',
    baselineHours: '基准工时(h)',
    loadFailed: '加载失败',
    trendRange: '趋势范围',
    trendMonths: '近 {n} 个月工时趋势',
    monthsSuffix: ' 个月',
    viewMonth: '查看月份',
    operatorBreakdown: '机手工时明细',
    emptyMonth: '该月暂无工时记录',
    missingDeviceMonth: '缺少设备或月份',
    close: '关闭',
    machinist: '机手',
    clockOutShort: '落机(h)',
    otShort: 'OT(h)',
    zhiShort: '中直(h)',
    tongxiaoShort: '通宵(h)',
    totalShort: '合计(h)',
  },
  userForm: {
    addTitle: '人员新增',
    accountRemark: '账号描述',
    accountRemarkPh: '说明创建该账号的用途，如：财务专员、设备管理员等',
    resignationRemark: '离职备注',
    resignationRemarkPh: '请输入离职备注',
    dailyPay: '日薪',
    hourlyPay: '时薪',
    allowance: '工資津貼',
    menuPermission: '菜单权限',
    restoreDefaultMenus: '恢复默认',
    selectAllMenus: '全选',
    clearMenus: '清空',
    menuPermissionTip: '普通管理员默认不含「系统维护-用户列表」，可按需勾选菜单及子菜单。',
    superAdminTip: '超级管理员默认拥有全部菜单权限，无需单独配置。',
    needUsername: '请输入用户名',
    needEnglishName: '请输入英文名',
    needIdCard: '请输入身份号码',
    needAddress: '请输入家庭住址',
    phUsername: '请输入用户名',
    phEnglishName: '请输入英文名',
    phIdCard: '请输入身份号码',
    phAddress: '请输入家庭住址',
    phRealName: '请输入姓名',
    phMobile: '请输入手机号',
    phEmail: '请输入邮箱',
  },
  versionControl: {
    tip: '全平台共用一套移动端版本配置，所有租户 App 统一读取此处设置。',
    androidVersion: '安卓版本号',
    iosVersion: 'iOS版本号',
    androidUrl: 'Android更新路径',
    iosUrl: 'iOS更新路径',
    compulsory: '是否强制更新',
    compulsorySwitch: '是否强制性',
    versionPh: '例如 1.0.0',
    urlPh: 'https://...',
    androidUrlPh: '请输入Android更新地址',
    iosUrlPh: '请输入iOS更新地址',
    versionInputPh: '请输入版本号',
    needAndroidVersion: '请输入安卓版本号',
    needIosVersion: '请输入iOS版本号',
    needIosUrl: '请输入iOS更新路径',
    needAndroidUrl: '请输入安卓更新路径',
    needCompulsory: '请选择是否强制更新',
    clear: '清空',
  },
  systemLegacy: {
    apply: '申请',
    applyHistory: '申请历史',
    link: '关联',
    buyer: '购物者',
    creditCode: '统一信用代码',
    socialCreditCode: '统一社会信用代码',
    applyDate: '申请日期',
    attachment: '模版附件',
    selectFile: '选择文件',
    preview: '预览',
    templateCode: '模版代码',
    paperType: '纸型',
    paperNormal: '普通',
    paperHalf: '二等分',
    paperThird: '三等分',
    uploadTime: '上传时间',
    orgStructure: '组织架构',
    roleAdd: '角色新增',
    roleName: '角色名称',
    roleAttr: '属性',
    roleId: '校色标识',
    roleNameLabel: '校色名称',
    roleSearchName: '校色名称',
    permAssign: '权限分配',
    printTemplate: '通用打印模版',
    purchaseOrder: '采购是货单',
    selectTemplate: '选择模版',
    selectColumn: '选择',
    paperShape: '纸形',
    templateCount: '本企业模版数量',
    buyerCol: '够货者',
    authorize: '授权',
    basicInfo: '基本信息',
    productAuth: '产品授权',
    nextStep: '下一步',
    productCategory: '产品类别',
    productCode: '产品编码',
    productName: '产品名称',
    manufacturer: '生产企业',
    spec: '规格',
    serialNo: '编号',
  },
  taskSpecial: {
    add: '新增',
    titleKeyword: '标题关键词',
    publisher: '发布人',
    published: '已发布',
    unpublished: '未发布',
    unlimited: '不限制',
    expired: '已截止',
    taskId: '任务ID',
    description: '描述',
    staffLimit: '人员限制',
    startTime: '开始时间',
    endTime: '结束时间',
    assignMember: '安排人员',
    auditTask: '审核任务',
    participants: '参与人员',
    members: '人员',
    staffPh: '请输入人员限制，0为不限制',
    endTimeOptionalPh: '不填写默认不过期',
    needTitle: '请输入名称',
    needDesc: '请输入描述',
    needUpload: '请上传资料',
    needStartTime: '请选择开始时间',
    needEndTime: '请选择结束时间',
    needScore: '请输入分值',
    needStaff: '请输入限制人员',
    needStatus: '请选择状态',
    imageOnly: '只能上传图片文件!',
  },
  scoreRecord: {
    recordId: '记录ID',
    recorderName: '记录人姓名',
    recorderUsername: '记录人用户名',
    recorderMobile: '记录人手机',
    reason: '积分原因',
    points: '分值',
    keywordPlaceholder: '姓名/账号/电话',
    time: '时间',
    createdAt: '创建时间',
  },
  auditLog: {
    tip: '展示管理后台 API 异常与拒绝访问记录（403/4xx/5xx），便于运营排查权限与接口问题。',
    method: '方法',
    path: '路径',
    httpStatus: 'HTTP状态',
    errorMsg: '错误信息',
    operator: '操作人',
    operatedAt: '时间',
    keywordPlaceholder: '路径/用户名/姓名',
    loadFailed: '加载失败',
  },
  messageAdmin: {
    add: '添加消息',
    edit: '编辑消息',
    addBtn: '添加消息',
    messageType: '消息类型',
    typeSystem: '系统通知',
    typeReminder: '提醒',
    typeAnnouncement: '公告',
    colType: '消息类型',
    colTitle: '标题',
    colContent: '内容',
    colCreatedAt: '创建时间',
    titlePh: '请输入消息标题',
    contentPh: '请输入消息内容',
    typePh: '请选择消息类型',
    needType: '请选择消息类型',
    needTitle: '请输入消息标题',
    titleLength: '标题长度在 1 到 100 个字符',
    needContent: '请输入消息内容',
    contentLength: '内容长度在 1 到 1000 个字符',
    deleteConfirm: '确定要删除这条消息吗？',
    deleteTitle: '删除确认',
    deleteNeedBackend: '删除功能需要后端支持，请联系开发人员添加删除接口',
    retryFailed: '操作失败，请重试',
  },
  notFound: {
    title: '页面不存在',
    desc: '您访问的页面不存在或已被移除',
    backHome: '返回首页',
  },
}
